import axios from "axios";
import config from "./config";

const http = axios.create({
    baseURL: config.baseURL,
    timeout: 300000,
})

// 请求拦截器
http.interceptors.request.use(config => {
  if (!config.url.includes('/uploads')) {
    const token = localStorage.getItem('token');
    if (token) {
      if (['get', 'delete'].includes(config.method)) {
        config.params = {
          ...config.params, 
          token, 
        };
      } else {
        config.data = {
          ...config.data, 
          token, 
        };
      }
    }
  }
  return config;
}, err => {
  return Promise.reject(err);
});
http.interceptors.response.use(res=>{
    const contentType = res.headers['content-type'];

    if (contentType && contentType.includes('application/json')) {
      try {
        if (typeof res.data === 'string') {  
          const parsedData = JSON.parse(res.data);
          if (parsedData.code === -10009 || parsedData.code === -10010) {
            localStorage.removeItem('token');  
            localStorage.setItem("userInfo",JSON.stringify({nickname: '',headimg: ''}));
            window.location.hash = '#/login';
            return Promise.reject(new Error('请重新登陆'));
          }
          return parsedData;  
        } else {
          return res.data;
        }
      } catch (error) {
        return res;  
      }
    } else {
      return res;
    }
},err=>{
    console.error('API Error:', err.response?.data?.message || err.message);
    return Promise.reject(err);
})


export default http